// src/utils/commonApiError.tsx
export interface ApiError {
  message: string;
  status?: number;
}

export const handleApiError = (error: any): ApiError => {
  console.log(
    "[API Error Handler] Processing error...",
    error,
    "--message--: ",
    error.message,
    "---status: ",
    error.status,
    error.statusCode,
    "str:",
    JSON.stringify(error)
  );

  if (error.response) {
    const errorResponse = {
      message: error.response.data.message || "An error occurred",
      status: error.response.status,
    };
    console.log("[API Error Handler] Formatted error response:", errorResponse);
    return errorResponse;
  }

  const networkError = {
    message: "Network error occurred",
    status: 500,
  };
  console.log("[API Error Handler] Network error formatted:", networkError);
  return networkError;
};
